import React, { useMemo } from 'react';

import DropdownLabel from 'components/lib/DropdownLabel';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { handleSetSelectedParentCommunity } from 'store/slices/globalSlice';

const ParentCommunitySelector = () => {
  const dispatch = useAppDispatch();

  const { selectedCommunity, selectedParentCommunity } = useAppSelector((state) => state.global);

  const options = useMemo(() => {
    return (selectedCommunity?.parentCommunities ?? []).map((community) => ({
      id: community.id,
      name: community.comunity_name,
    }));
  }, [selectedCommunity]);

  const handleSelect = (item: any) => {
    const community = (selectedCommunity?.parentCommunities ?? []).find((c) => c.id === item);
    dispatch(handleSetSelectedParentCommunity(community));
  };

  return <DropdownLabel selection={selectedParentCommunity?.id as number} options={options} onSelect={handleSelect} />;
};

export default ParentCommunitySelector;
